$(function () {
    // Common function: play selected video and stop all others
    function playVideo(wrapper, playBtn, poster, video) {
        // Stop all other videos
        $("video").each(function () {
            this.pause();
            this.currentTime = 0;
            this.style.display = "none";
        });
        $(".poster, .banner-poster").show();
        $(".play-btn").show();

        // Play selected video
        poster.style.display = "none";
        playBtn.style.display = "none";
        video.style.display = "block";
        video.play();
    }

    // Handle banner-home_video blocks
    $(".banner-home_video").each(function () {
        const wrapper = $(this);
        const playBtn = wrapper.find(".play-btn")[0];
        const video   = wrapper.find(".banner-video")[0]; 
        const poster  = wrapper.find(".banner-poster")[0];

        playBtn.addEventListener("click", () => {
            playVideo(wrapper, playBtn, poster, video);
        });

        video.addEventListener("ended", () => {
            poster.style.display = "block";
            playBtn.style.display = "flex";
            video.style.display = "none";
        });
    });

    // Handle video-wrapper blocks
    $(".video-wrapper").each(function () {
        const wrapper = $(this);
        const playBtn = wrapper.find(".play-btn")[0];
        const video   = wrapper.find(".video")[0];
        const poster  = wrapper.find(".poster")[0];

        playBtn.addEventListener("click", () => {
            playVideo(wrapper, playBtn, poster, video);
        });

        video.addEventListener("ended", () => {
            poster.style.display = "block";
            playBtn.style.display = "flex";
            video.style.display = "none";
        });
    });
});
